// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2fDnD","productName":"Table_productName__20LuM"};